import React, { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import ContactsSidebar from '../../Contacts/components/ContactsSidebar';
import ShowSidebarButton from './ShowSidebarButton';

const MOBILE_QUERY = '(max-width: 767.98px)';

function CrmPageLayout({
  team,
  activeSidebarKey,
  title,
  subtitle,
  breadcrumb,
  primaryAction,
  secondaryAction,
  children,
  mainTopMargin = 4,
}) {
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    if (typeof window !== 'undefined' && window.matchMedia) {
      return !window.matchMedia(MOBILE_QUERY).matches;
    }
    return true;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;

    const mql = window.matchMedia(MOBILE_QUERY);
    const handleChange = (e) => {
      if (e.matches) {
        setSidebarOpen(false);
      }
    };

    mql.addEventListener('change', handleChange);
    return () => mql.removeEventListener('change', handleChange);
  }, []);

  return (
    <div className="contacts-page">
      <div className="crm-layout-flex">
        {sidebarOpen && (
          <div className="crm-layout-sidebar">
            <ContactsSidebar
              team={team}
              activeKey={activeSidebarKey}
              onToggleSidebar={() => setSidebarOpen(false)}
            />
          </div>
        )}

        <div className="contacts-main-column" style={{ marginTop: mainTopMargin }}>
          {(title || !sidebarOpen) && (
            <div className={title ? 'mb-4' : 'mb-2'}>
              {breadcrumb && <div className="mb-2">{breadcrumb}</div>}
              <div className="d-flex justify-content-between align-items-start mb-2">
                {!sidebarOpen && (
                  <ShowSidebarButton onClick={() => setSidebarOpen(true)} />
                )}

                {title && (
                  <div className="flex-grow-1">
                    <h2 className="h4 mb-1">{title}</h2>
                    {subtitle && <p className="text-muted mb-0">{subtitle}</p>}
                  </div>
                )}

                {(primaryAction || secondaryAction) && (
                  <div className="d-flex align-items-center" style={{ gap: '0.75rem' }}>
                    {secondaryAction}
                    {primaryAction && (
                      <button
                        type="button"
                        className="btn btn-setlist-primary btn-lg"
                        onClick={primaryAction.onClick}
                      >
                        {primaryAction.iconClass && (
                          <i
                            className={primaryAction.iconClass}
                            style={{ fontSize: '16px' }}
                            aria-hidden="true"
                          />
                        )}
                        <span>{primaryAction.label}</span>
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}

          {children}
        </div>
      </div>
      <ToastContainer icon={false} />
    </div>
  );
}

export default CrmPageLayout;
